import type { CreateLumappsChatAgentConfig } from '@lumapps/agent-chat/api';

import { AgentType } from './types';

/** Feature token for the agent hub features */
export const AGENT_HUB_FEATURE_TOKEN = 'ai-agents';

/** Feature token for the agent hub features still in alpha stage */
export const AGENT_HUB_ALPHA_FEATURE_TOKEN = 'ai-agents-alpha';

/** Feature token for the agent hub features still in beta stage */
export const AGENT_HUB_BETA_FEATURE_TOKEN = 'ai-agents-beta';

/** Base path for the agent hub admin pages */
export const AGENT_HUB_ADMIN_BASE_PATH = 'agent-hub';

/**
 * Some agents are "static" and needs to be initiated by the frontend.
 * For these, we need to directly target their IDS.
 */
export const NATIVE_AGENTS = {
    askAi: {
        id: '0af756ae-3e8d-4bd1-9724-16e45ebc1908',
    },
    learning: {
        id: 'c839a10c-ee83-41a9-adf9-bb80533dbcb3',
    },
    activity: {
        id: '633194fb-adf9-48c2-bfcc-ea6ca43d45e2',
    },
    broadcast: {
        id: 'bcc7af44-eedc-4eab-9c35-ccd8d2995084',
    },
} as const;

/** Default params an Ai Agent should be initiated with */
export const DEFAULT_AI_AGENT_PARAMS: CreateLumappsChatAgentConfig = {
    agentId: undefined,
    initialMessages: [],
};

/** Custom events received while streaming `/chat` chunks */
export const CUSTOM_EVENTS = {
    /** The current agent requests to hand off the conversation to a different agent */
    AGENT_HANDOFF: 'agent_handoff_requested',
    /** The agent provides source document links used to generate an assistant message */
    ANSWER_RESOURCES: 'answer_resources',
};

/** Array of all agent types possible */
export const AGENT_TYPES_ARRAY = Object.values(AgentType);
